'use client';
import { useState } from 'react';
import AccountInput from '@/app/account/_components/AccountInput';
import { Button } from '@/components/Button';
import styles from './PortalPasswordForm.module.scss';
export function PortalPasswordForm(): JSX.Element {
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  return <form className={styles.form} onSubmit={async (event) => {
    event.preventDefault(); if (busy) return; setBusy(true); setError('');
    try {
      const response = await fetch('/api/portal-password/login', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ password }) });
      const body = await response.json();
      if (!response.ok || !body.success) throw new Error(body.error?.message ?? 'Unable to sign in.');
      window.location.assign('/');
    } catch (error) { setError(error instanceof Error ? error.message : 'Unable to sign in.'); setBusy(false); }
  }}>
    <div className={styles.divider}><span />or<span /></div>
    <AccountInput label="Portal password" id="shared-portal-password" type="password" autoComplete="current-password" required maxLength={128} value={password} disabled={busy} onChange={(event) => setPassword(event.target.value)} />
    <Button variant="big" tone="black" type="submit" disabled={busy}>{busy ? 'Signing in…' : 'Continue with Portal password'}</Button>
    {error && <p className={styles.error} role="alert">{error}</p>}
    <p className={styles.disclaimer}>Social sign-in is recommended. You can also use a Portal password shared with you.</p>
  </form>;
}
export function PortalGuestLogout({ className }: { className?: string }): JSX.Element {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  return <div><button className={className} type="button" disabled={busy} onClick={async () => {
    setBusy(true); setError('');
    try {
      const response = await fetch('/api/portal-password/logout', { method: 'POST' });
      if (!response.ok) throw new Error('Unable to sign out. Please try again.');
      window.location.assign('/login');
    } catch (error) { setError(error instanceof Error ? error.message : 'Unable to sign out.'); setBusy(false); }
  }}>{busy ? 'Signing out…' : 'Log Out'}</button>{error && <p role="alert">{error}</p>}</div>;
}
